import { render } from "./SendMultipleMessageView.vue?vue&type=template&id=5160c044&scoped=true&ts=true"
import script from "./SendMultipleMessageView.vue?vue&type=script&lang=ts"
export * from "./SendMultipleMessageView.vue?vue&type=script&lang=ts"

import "./SendMultipleMessageView.vue?vue&type=style&index=0&id=5160c044&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5160c044"]])

export default __exports__